import * as R from 'ramda'

export function setCollapsed(state, action) {
  const { postId, collapsed } = action.payload
  return R.assocPath([postId, 'collapsed'], collapsed, state)
}

export function setAscending(state, action) {
  const { postId, ascending } = action.payload
  return R.assocPath([postId, 'ascending'], ascending, state)
}

export function setLimit(state, action) {
  const { postId, limit } = action.payload
  return R.assocPath([postId, 'limit'], limit, state)
}
